<template>
    <div>
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <section class="faq_section">
            
            <div class="container">
                <div class="faq-title">
                    <div class="faq-title-content">
                        {{ data[0].heading }}
                    </div>
                </div>
                <div class="faq_accordion_section">
                    <div class="row justify-content-center">
                        <div class="col-12 mb-5">
                            <div class="nav nav-pills  nav-justified shadow-sm rounded-sm" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                <p v-html="data[0].detail" style="padding: 26px; text-align: justify;"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
    name: "AccessibilityStatement",
    components: {
        Loading
    },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            loader: "bars",
            data: [],
            type: "gbbsix"
        }
    },
    created() {
        document.title = "Geek Buy Back - Accessibility Statement";
        this.getAccessibilityStatementData();
    },
    methods: {
        getAccessibilityStatementData: function() {
            this.isLoading = true;
            var config = {
                method: "GET",
                url: this.$api + "api/geek-security/" + this.type
            };
            this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    this.data = response.data.data;
                    console.log(this.data);
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        }
    }
}
</script>
